exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question-component[data-v-7dc0bba6]{margin-bottom:2rem}.form-group[data-v-7dc0bba6]{margin-bottom:0}", ""]);

// exports
